import React from "react";
import { useLang } from "../i18n";
import { useAuth } from "../context/AuthContext";
import api from "../api";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useLang();
  const { user } = useAuth();
  const switchTo = (l) => {
    setLang(l);
    if (user) api.post("/auth/lang", { lang: l }).catch(() => {});
  };
  return (
    <div data-testid="language-switcher" className="flex items-center rounded-full bg-[#0D0B38]/80 border border-white/12 p-1 text-sm font-bold">
      <button data-testid="lang-ar-btn" onClick={() => switchTo("ar")}
        className={`px-3 py-1 rounded-full transition-colors ${lang === "ar" ? "bg-gradient-to-r from-[#7625D8] to-[#9C42F5] text-white shadow" : "text-[#A5A0D6] hover:text-white"}`}>
        العربية
      </button>
      <button data-testid="lang-en-btn" onClick={() => switchTo("en")}
        className={`px-3 py-1 rounded-full transition-colors ${lang === "en" ? "bg-gradient-to-r from-[#7625D8] to-[#9C42F5] text-white shadow" : "text-[#A5A0D6] hover:text-white"}`}>
        English
      </button>
    </div>
  );
}
